module.exports = __webpack_public_path__ + "img/sest-4.2b6d0332.svg";